export default function Hero() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[720px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20minimalist%20creative%20workspace%20aesthetic%20with%20soft%20beige%20cream%20and%20sage%20green%20abstract%20organic%20flowing%20waves%2C%20delicate%20textured%20paper%20background%2C%20subtle%20scattered%20fashion%20accessory%20silhouettes%2C%20dreamy%20atmospheric%20editorial%20style%2C%20clean%20modern%20composition%20with%20lots%20of%20negative%20space%2C%20warm%20ivory%20to%20soft%20terracotta%20gradient%2C%20sophisticated%20artistic%20mood&width=1800&height=1000&seq=hero-main-fresh-v2&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-white/40 via-white/10 to-background-50"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-6 md:px-10 py-20 md:py-28 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary-100/80 text-primary-700 text-xs font-semibold mb-6">
          <i className="ri-sparkling-line text-sm w-4 h-4 flex items-center justify-center"></i>
          Updated 2026 Database
        </div>

        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-foreground-950 leading-tight mb-5">
          Sugargoo Spreadsheet
          <br />
          <span className="text-primary-500">The Ultimate Finds Database</span>
        </h1>

        <p className="text-base md:text-lg text-foreground-600 max-w-2xl mx-auto mb-8 leading-relaxed">
          Discover thousands of curated Sugargoo finds, product spreadsheets, shopping guides, shipping information and expert reviews — all in one place.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            Sugargoo Spreadsheet
            <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center"></i>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-full border-2 border-foreground-200 text-foreground-800 font-semibold text-sm hover:border-foreground-400 hover:text-foreground-950 transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            Buy It Now
            <i className="ri-shopping-cart-line w-4 h-4 flex items-center justify-center"></i>
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6 mt-10 text-xs text-foreground-500">
          <span className="inline-flex items-center gap-1.5">
            <i className="ri-checkbox-circle-line text-primary-500 text-sm w-4 h-4 flex items-center justify-center"></i>
            Updated Product Database
          </span>
          <span className="inline-flex items-center gap-1.5">
            <i className="ri-checkbox-circle-line text-primary-500 text-sm w-4 h-4 flex items-center justify-center"></i>
            Beginner Friendly Guides
          </span>
          <span className="inline-flex items-center gap-1.5">
            <i className="ri-checkbox-circle-line text-primary-500 text-sm w-4 h-4 flex items-center justify-center"></i>
            Independent Research
          </span>
          <span className="inline-flex items-center gap-1.5">
            <i className="ri-checkbox-circle-line text-primary-500 text-sm w-4 h-4 flex items-center justify-center"></i>
            Global Shopping Resources
          </span>
        </div>
      </div>
    </section>
  );
}